import React from 'react'
// import { useIsLargeDesktop } from '../../../../hooks'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const UnclaimedBusinessProfile = props => {
  // const isLargeDesktop = useIsLargeDesktop()

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6" color="#0A78CD" sx={{ margin: '0px 8px 20px 8px' }}>
        Markaaz News
      </Typography>
    </Box>
  )
}

export default UnclaimedBusinessProfile
